import { getInstrumentTypeConfig } from '../config';
import { instrumentTypes } from '../constants';
import { instrumenForm, instrumenRedux, instrumentConsole, instrumentDOM, instrumentFetch, instrumentXHR } from '../types';
const instrumentHandlers = {
    [instrumentTypes.DOM]: instrumentDOM,
    [instrumentTypes.FORM]: instrumenForm,
    [instrumentTypes.REDUX]: instrumenRedux,
    [instrumentTypes.CONSOLE]: instrumentConsole,
    [instrumentTypes.XHR]: instrumentXHR,
    [instrumentTypes.FETCH]: instrumentFetch
};
/**
 * Add handler that will be called when given type of instrumentation triggers.
 *
 * @param {Object} handler
 * @param {String} handler.type - handler type name
 * @param {Function} handler.callback - handler callback function
 * @param {Function} handler.transformer - optional transformer function
 * @param {Object} additionalHandlers
 *
 */ export const addBasicInstrumentationHandler = (handler, additionalHandlers = {})=>{
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    const { type, callback, transformer } = handler;
    const { pushHandler, instrumented, init } = getInstrumentTypeConfig(type);
    const clean = pushHandler({
        handler: callback,
        transformer
    });
    if (instrumented) {
        return;
    }
    init();
    const handlersBag = {
        ...instrumentHandlers,
        ...additionalHandlers
    };
    if (!handlersBag.hasOwnProperty(type)) {
        console.warn(`unknown instrumentation type: ${type}`);
        return clean;
    }
    handlersBag[type]?.();
    return clean;
};
